<template>
  <section>
    <navbar v-if="!isScreen()" />
    <error-box />
    <router-view></router-view>
  </section>
</template>

<script>
import navbar from "@/components/navbar"
import ErrorBox from "@/components/error-box"
import { actions } from "@/store"

export default {
  name: "app",
  components: {
    navbar,
    ErrorBox
  },
  methods: {
    isScreen() {
      return /screen\/|device/i.test(this.$route.path)
    }
  },
  mounted() {
    actions.initConnectionListener()
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";
@import "../node_modules/bulma/bulma.sass";
$fa-font-path: "../node_modules/font-awesome/fonts";
@import "../node_modules/font-awesome/scss/font-awesome.scss";

section {
  padding: 12px 12px 0 12px;
}

//TODO: create padding helpers
.is-p1 {
  padding: 0.5rem 1rem;
}
.is-pt-large {
  padding-top: 3rem;
}
</style>
